import { LMModel } from '@form/model';

export class AppConstants {

  // Toast Result Attribute Values
  public static TRA_ACTION_COMPLETED = 'ActionCompleted';
  public static TRA_ACTION_FAILED = 'ActionFailed';
  public static TRA_ACTION_CANCELED = 'ActionCancelled';
  public static TRA_ACTION_PARTIALLY_COMPLETED = 'ActionPartiallyCompleted';

  public static UNMODIFIED_CONFIRMATION_REQUIRED = 'UNMODIFIED_CONFIRMATION_REQUIRED';

  public static PAGE_SIZES = [ 5, 10, 20, 50, 100, 200 ];

  public static PANEL_TYPE_PANEL = 'Panel';
  public static PANEL_TYPE_MULTI_PANE_PANEL = 'MultiPanePanel';
  public static PANEL_TYPE_HTTP_URL = 'HttpUrlPanel';
  public static PANEL_TYPE_LIST_PANEL = 'ListPanel';

  public static URLSEG_PDL_OR_DA_INDEX     = 0;
  public static URLSEG_WEBAPP_INDEX        = 1;
  public static URLSEG_RESOURCE_TYPE_INDEX = 2;
  public static URLSEG_RESOURCE_ID_INDEX   = 3;

  public static ELEMENT_ID_SUFFIX_DASHBOARDPANEL = '_dashboardpanel';

  public static ELEMENT_ID_SUFFIX_DETAIL_SECTION_TABSET = '_tabs';
  public static ELEMENT_ID_SUFFIX_DETAIL_SECTION_TAB = '_tab';

  public static ELEMENT_ID_SUFFIX_FORM_PANEL_TABSET = '_tabs';
  public static ELEMENT_ID_SUFFIX_FORM_PANEL_TAB = '_tab';

  public static ELEMENT_ID_SUFFIX_STEP_PANEL_TABSET = '_tabs';
  public static ELEMENT_ID_SUFFIX_STEP_PANEL_TAB = '_tab';

  public static TRUE = true;
  public static FALSE = false;

  // Page Pane Layout types;
  public static PANE_LAYOUT_TYPE = 1;

  public static ALPHA = 'ALPHA';
  public static ALPHALOWER = 'ALPHALOWER';
  public static ALPHARIGHT = 'ALPHARIGHT';
  public static ALPHAUPPER = 'ALPHAUPPER';
  public static BCD = 'BCD';
  public static BINARY = 'BINARY';
  public static BINARYDOCUMENT = 'BINARYDOCUMENT';
  public static BINARYOBJECT = 'BINARYOBJECT';
  public static BOOLEAN = 'BOOLEAN';
  public static CARDVIEW = 'CARDVIEW';
  public static CHECKCONTROL = 'CHECKCONTROL';
  public static CURRENCY = 'CURRENCY';
  public static FORMBUTTON = 'FORMBUTTON';
  public static FORMCHECKBOX = 'FORMCHECKBOX';
  public static FORMREFERENCE = 'FORMREFERENCE';
  public static FORMTEXT = 'FORMTEXT';
  public static IMAGE = 'IMAGE';
  public static LISTREFERENCE = 'LISTREFERENCE';
  public static MMDD = 'MMDD';
  public static NAVIGATION  = 'NAVIGATION';
  public static NOREPRESENTATION  = 'NOREPRESENTATION';
  public static NUMERIC  = 'NUMERIC';
  public static PERCENT  = 'PERCENT';
  public static PERCENT_SIGN  = '%';
  public static PERCENT_FORMAT  = '### %';
  public static SUBFORM  = 'SUBFORM';
  public static TEXT  = 'TEXT';
  public static TEXTAREA  = 'TEXTAREA';
  public static TIME  = 'TIME';
  public static TIMESTAMP = 'TIMESTAMP';
  public static UNIQUEID = 'UNIQUEID';
  public static VERSIONID = 'VERSIONID';
  public static YYYY = 'YYYY';
  public static YYYYMM = 'YYYYMM';
  public static YYYYMMDD = 'YYYYMMDD';

  public static STATUS_COMPLETED = 'COMPLETED';
  public static STATUS_DOES_NOT_EXIST = 'DOES_NOT_EXIST';
  public static STATUS_SYSTEM_ERROR = 'SYSTEM_EXCEPTION';
  public static STATUS_UNAUTHORIZED = 'UNAUTHORIZED';
  public static STATUS_SSO_REDIRECTING = 'REDIRECTING';
  public static VIEW_EXCEPTION = 'VIEW_EXCEPTION';
  public static INTERNAL_ERROR = 'INTERNAL_ERROR';
  public static FILE_UPLOAD_EXCEPTION = 'FILE_UPLOAD_EXCEPTION';
  public static CONFIRMATION_REQUIRED = 'CONFIRMATION_REQUIRED';
  public static STATUS_INPROGRESS = 'INPROGRESS';

  public static CALL_POST_CONFIRMATION = 'Call_Post_Confirmation';
  public static ALL_PARAMS_SET = 'ALL_PARAMS_SET';
  public static PARAM_FROMLIST = 'fromlist';
  public static NOOP = 'NOOP';

  // -----------------------------------------------------------------
  // todo Need constants for all csks and corrosponding definition
  //  in LMUrlParams in lm-global.d.ts
  // -----------------------------------------------------------------
  public static PARAM_CSK_ASOFDATE = 'csk.asofdate';
  public static PARAM_CSK_SHOWDELETEDRECORDS = 'csk.showdeletedrecords';
  public static PARAM_CSK_BANNERINROUTE = 'csk.bannerinroute';
  public static PARAM_CSK_ROUTEREUSE = 'csk.routereuse';
  public static PARAM_CSK_LIGHTCONTEXTFORM = 'csk.lightcontextform';
  public static PARAM_CSK_VIEWARCHIVE = 'csk.archivemode';


  // field bind id suffixes
  public static FIELD_STATE_SUFFIX = 'States';
  public static STATUS_YES = 'YES';
  public static STATUS_NO = 'NO';
  public static STATUS_OK = 'OK';
  public static STATUS_OK_TO_ALL = 'OKToAll';
  public static STATUS_CANCEL = 'CANCEL';

  public static ACTION_OPEN = '_open';

  public static ACTION_TYPE_UPDATE = 'UPDATE';
  public static ACTION_TYPE_DELETE = 'DELETE';
  public static ACTION_TYPE_CREATE = 'CREATE';
  public static ACTION_TYPE_CREATE_WITHIN = 'CREATE_WITHIN';
  public static ACTION_TYPE_FUNCTION = 'FUNCTION';
  public static ACTION_TYPE_SET = 'SET';
  public static ACTION_TYPE_IMPORT = 'IMPORT';

  public static ACTION_TYPE_AUDIT_OVERRIDE = 'AUDIT_OVERRIDE';
  public static ACTION_TYPE_AUDIT_UPDATE  = 'AUDIT_UPDATE';
  public static ACTION_TYPE_CHANGE_EFFECTIVEDATE = 'CHANGE_EFFECTIVEDATE';
  public static ACTION_TYPE_AUDIT_DELETE = 'AUDIT_DELETE';
  public static ACTION_TYPE_TEMPLATEFORM_SAVE = 'TEMPLATEFORM_SAVE';
  public static ACTION_TYPE_COPY_ROW = 'COPY_ROW';

  public static ACTIONSPEC_TEMPLATEFORM_SAVE: any = {
    name: '_saveTemplateForm',
    type: AppConstants.ACTION_TYPE_TEMPLATEFORM_SAVE
  };

  public static ACTIONREDIRECT_TYPE_ACTION = 'ACTION';
  public static ACTIONREDIRECT_TYPE_URL = 'URL';
  public static ACTIONREDIRECT_TYPE_VIEW = 'VIEW';
  public static ACTIONREDIRECT_TYPE_FOLDER = 'FOLDER';
  public static ACTIONREDIRECT_TYPE_PAGE = 'PAGE';
  public static ACTIONREDIRECT_TYPE_LIST = 'LIST';
  public static ACTIONREDIRECT_TYPE_NAVIGATION = 'NAVIGATION';
  public static ACTIONREDIRECT_TYPE_NEWWEBAPP = 'NEWWEBAPP';
  public static ACTIONREDIRECT_TYPE_WATCH = 'WATCH';

  public static BUTTON_TYPE_ACTION = 'action';
  public static BUTTON_TYPE_STANDARD_ACTION = 'standard';
  public static BUTTON_TYPE_NAVIGATION = 'navigation';
  public static BUTTON_TYPE_RELATED = 'related';
  public static BUTTON_TYPE_HTTPURL = 'httpurl';
  public static BUTTON_TYPE_FORMINVOKE = 'forminvoke';
  public static BUTTON_TYPE_FORMTEXT = 'formtext';
  public static BUTTON_TYPE_PROCESSFLOW = 'processflow';
  public static BUTTON_TYPE_LIST_REFERENCE = 'listReference';
  public static BUTTON_TYPE_SUBFORM = 'subform';
  public static BUTTON_TYPE_HELPERLIST = 'helperList';
  public static BUTTON_TYPE_FORMBUTTON = 'FORMBUTTON';
  public static BUTTON_TYPE_SHOWEDITOR = 'showeditor';
  public static BUTTON_TYPE_VIEWDOCUMENT = 'viewdocument';
  public static BUTTON_TYPE_EXPORTDOCUMENT = 'exportdocument';
  public static BUTTON_TYPE_CHART = 'chart';
  public static BUTTON_TYPE_CUBE = 'cube';
  public static BUTTON_TYPE_CALENDAR = 'calendar';
  public static BUTTON_TYPE_REGISTRATION = 'registration';
  public static BUTTON_TYPE_SIGNIN = 'signin';
  public static BUTTON_TYPE_SIGNOUT = 'signout';
  public static BUTTON_TYPE_PERSONALIZE = 'personalize';
  public static BUTTON_TYPE_BUSTASK = 'bustask';

  // public static LISTTYPE_DEFAULT = 'default';
  // public static LISTTYPE_SELECT = 'select';
  // public static LISTTYPE_HELPER = 'helper';
  // public static LISTTYPE_DASHBOARD = 'dashboard';
  // public static LISTTYPE_FORMLIST = 'formlist';
  // public static LISTTYPE_MULTILIST = 'multilist';
  // public static LISTTYPE_MULTIPANE = 'multipane';
  // public static LISTTYPE_DETAILSECTION = 'detailsectionlist';
  // public static LISTTYPE_POPOVER = 'popover';
  // public static LISTTYPE_CUBEVIEW = 'cubeview';

  // List view types
  public static LISTVIEWTYPE_GRID: 'gridList' = 'gridList';
  public static LISTVIEWTYPE_LISTVIEW: 'listView' = 'listView';
  public static LISTVIEWTYPE_HIERARCHY: 'hierarchy' = 'hierarchy';
  public static LISTVIEWTYPE_CALENDAR: 'calendar' = 'calendar';
  public static LISTVIEWTYPE_CHART: 'chart' = 'chart';
  public static LISTVIEWTYPE_IMAGELIST: 'imageList' = 'imageList';
  public static LISTVIEWTYPE_LIST: 'list' = 'list';
  public static LISTVIEWTYPE_TREE: 'tree' = 'tree';
  public static LISTVIEWTYPE_FILTERLIST: 'filterList' = 'filterList';
  public static LISTVIEWTYPE_GALLERY: 'gallery' = 'gallery';

  // List Details view types
  public static LISTVIEWTYPE_DETAIL_LIST = 'list';
  public static LISTVIEWTYPE_DETAIL_CARDVIEW = 'cardview';
  public static LISTVIEWTYPE_DETAIL_STANDARDFORM = 'standardform';
  public static LISTVIEWTYPE_DETAIL_INSTANCECOUNTCHART = 'instancecountchart';
  public static LISTVIEWTYPE_DETAIL_URL = 'url';

  // List column alignment
  public static ALIGN_LEFT = 'left';
  public static ALIGN_RIGHT = 'right';
  public static ALIGN_CENTER = 'center';

  // Chart
  public static MULTILIST_CHART_HEIGHT  = 450; // this should probably be in css somewhere.- Phillip
  public static CHART_FORM_TYPE = 'formchart';
  public static CHART_MAX_PIE_SLICES = 7;
  public static CHART_SWITCH_TO_LIST_TYPE = 'list';

  // Form Modes
  public static MODE_CREATE = 'create';
  public static MODE_OPEN = 'open';
  public static MODE_ACTION = 'action';

  // Tab Types
  public static TABTYPE_TABS = 'tabs';
  public static TABTYPE_STEP = 'step';
  public static TABTYPE_WIZARD = 'wizard';

  // Form sub-types (shares the dataview)
  public static FORMSUBTYPE_RESPONSEREQD = 'ResponseReqd';
  public static FORMSUBTYPE_COMPOUNDFLDFLAT = 'CompoundFldFlat';
  public static FORMSUBTYPE_COMPOUNDFLD = 'CompoundFld';

  // Does not share the dataview, but if the form type is Search, then set the subtype for cube lists.
  public static FORMSUBTYPE_CUBESEARCHFORM = 'CubeSearchForm';
  /*
   * Keep these in sync with the constants in FormViewBuilder
   */
  // form panel types
  public static FORM_PANELTYPE_FORMLIST = 'formlist';
  public static FORM_PANELTYPE_FORM = 'form';
  public static FORM_PANELTYPE_MULTILIST = 'multilist';
  public static FORM_PANELTYPE_TEMPLATEFORM = 'templateform';
  public static FORM_PANELTYPE_INDEPENDENTFORM = 'independentform';
  public static FORM_PANELTYPE_TEMPLATEFORMLIST = 'templateformlist';
  public static FORM_PANELTYPE_ACTIONIS = 'actionis';
  public static FORM_PANELTYPE_RELATEDFORM = 'relatedform';
  public static FORM_PANELTYPE_CHART = 'Chart';
  public static FORM_PANELTYPE_INSTANCECHART = 'instancechart';
  public static FORM_PANELTYPE_URL = 'url';
  public static FORM_PANELTYPE_DASHBOARD = 'dashboard';

  // form panel transaction types
  public static FORM_PANEL_TRANSACTION_COMMIT_TYPE = 'commit';
  public static FORM_PANEL_TRANSACTION_VALIDATION_TYPE = 'validation';
  public static FORM_PANEL_TRANSACTION_NONE_TYPE = 'none';

  // form context menu actions
  public static FORM_CONTEXTMENUACTION_SHOWCOMPACTFORM = 'CompactForm';
  public static FORM_CONTEXTMENUACTION_SHOWDRILLAROUND = 'DrillAround';
  public static FORM_CONTEXTMENUACTION_SHOWFIELDHISTORY = 'ShowFieldHistory';
  public static FORM_CONTEXTMENUACTION_SHOWPENDINGCHANGES = 'ShowPendingChanges';
  public static FORM_CONTEXTMENUACTION_SHOWTRANSLATIONS = 'ShowTranslations';
  public static FORM_CONTEXTMENUACTION_TEXTVARIABLES = 'TextVariables';
  public static FORM_CONTEXTMENUACTION_DEFINE = 'Define';
  public static FORM_CONTEXTMENUACTION_TRANSLATE = 'Translate';
  public static FORM_CONTEXTMENUACTION_GENAI = 'GenAI';
  public static FORM_CONTEXTMENUACTION_SELECT = 'Select';
  public static FORM_CONTEXTMENUACTION_SCAN = 'Scan';

  public static RESOURCE_SPEC_DELIMITER = '.';
  public static RESOURCE_KEY_DELIMITER = ',';
  public static RESOURCE_KEY_SECTION_DELIMITER_COLON = ':';
  public static RESOURCE_KEY_SECTION_DELIMITER_PIPE = '|';
  public static TEXT_VAR_START_DELIMITER = '{';
  public static TEXT_VAR_END_DELIMITER = '}';

  // Custom Home Pgae Param
  public static CUSTOMHP='customhp';

  // standard toolbar typesq
  public static STANDARD_TOOLBAR_OPEN = 'StandardOpen';
  public static STANDARD_SAVE = 'StandardSave';
  public static STANDARD_TOOLBAR_SAVENEW = 'StandardSaveAndNew';
  public static STANDARD_TOOLBAR_SAVECLOSE = 'StandardSaveAndClose';
  public static STANDARD_TOOLBAR_SAVEASDRAFT = 'StandardSaveAsDraft';
  public static STANDARD_TOOLBAR_EXPORTPDF = 'StandardExportToPDF';
  public static STANDARD_TOOLBAR_EXPORTCSV = 'StandardExportToCSV';
  public static STANDARD_TOOLBAR_CREATEREPORT = 'StandardCreateReport';
  public static STANDARD_TOOLBAR_RELATEDREPORT = 'StandardRelatedReport';
  public static STANDARD_TOOLBAR_RELATEDREPORT_MORE = 'StandardRelatedReportMore';
  public static STANDARD_TOOLBAR_PERSONALIZE = 'StandardPersonalize';
  public static STANDARD_TOOLBAR_SEARCH = 'StandardSearch';
  public static STANDARD_TOOLBAR_RUNFILTER = 'RunFilter';
  public static STANDARD_TOOLBAR_CLEARFILTER = 'ClearFilter';
  public static STANDARD_TOOLBAR_ADDTAG = 'AddTag';
  public static STANDARD_TOOLBAR_PRINTTOFILE = 'StandardPrintToFile';
  public static STANDARD_TOOLBAR_REFRESH = 'StandardRefresh';
  public static STANDARD_TOOLBAR_SORT = 'StandardSort';
  public static STANDARD_TOOLBAR_SORT_ORDER_ASCENDING = 'StandardSortOrderMenuAscending';
  public static STANDARD_TOOLBAR_SORT_ORDER_DESCENDING = 'StandardSortOrderMenuDescending';
  public static STANDARD_TOOLBAR_SORT_ORDER_MENUITEM = 'StandardSortOrderMenuItem';
  public static STANDARD_TOOLBAR_VIEWACTION = 'StandardViewAction';
  public static STANDARD_TOOLBAR_HELPERLIST = 'StandardHelperList';
  public static STANDARD_TOOLBAR_NAVIGATION = 'StandardNavigation';
  public static STANDARD_TOOLBAR_VIEWAUDIT = 'StandardViewAudit';
  public static STANDARD_TOOLBAR_VIEWFULLAUDIT = 'StandardViewFullAudit';
  public static STANDARD_TOOLBAR_DETAILFIELDS = 'StandardDetailFields';
  public static STANDARD_TOOLBAR_NEXTRECORD = 'StandardNextRecord';
  public static STANDARD_TOOLBAR_PREVRECORD = 'StandardPreviousRecord';
  public static STANDARD_TOOLBAR_CREATEMENU_BUTTON = 'StandardCreateMenuButton';
  public static STANDARD_TOOLBAR_ACTIONSMENU_BUTTON = 'StandardActionsMenuButton';
  public static STANDARD_TOOLBAR_OPTIONSMENU_BUTTON = 'StandardOptionsMenuButton';
  public static STANDARD_TOOLBAR_EXPORTMENU_BUTTON = 'StandardExportMenuButton';
  public static STANDARD_TOOLBAR_REPORTSMENU_BUTTON = 'StandardReportsMenuButton';
  public static STANDARD_TOOLBAR_PERSONALIZEMENU_BUTTON = 'StandardPersonalizeMenuButton';
  public static STANDARD_TOOLBAR_AUDITMENU_BUTTON = 'StandardAuditMenuButton';
  public static STANDARD_TOOLBAR_RELATEDMENU_BUTTON = 'StandardDrillAroundMenuButton';
  public static STANDARD_TOOLBAR_DRILLAROUND_BUTTON = 'StandardDrillAroundButton';
  public static STANDARD_TOOLBAR_CHARTMENU_BUTTON = 'StandardChartsMenuButton';
  public static STANDARD_TOOLBAR_ALLACTIONSMENU_BUTTON = 'StandardAllActionsMenuButton';
  public static STANDARD_TOOLBAR_EDITMODE = 'StandardEditMode';
  public static STANDARD_TOOLBAR_HELPERLISTMENU_BUTTON = 'StandardHelperListMenuButton';
  public static STANDARD_TOOLBAR_INLINECREATE = 'StandardInlineCreate';
  public static STANDARD_TOOLBAR_CREATEWITHIN = 'StandardCreateWithin';
  public static STANDARD_TOOLBAR_CREATE = 'StandardCreate';
  public static STANDARD_TOOLBAR_COPYROW = 'StandardCopyRow';
  public static STANDARD_TOOLBAR_UPDATE = 'StandardUpdate';
  public static STANDARD_TOOLBAR_DELETE = 'StandardDelete';
  public static STANDARD_TOOLBAR_CREATEMENU_MENU = 'StandardCreateMenuButtonMenu';
  public static STANDARD_TOOLBAR_RELATEDMENU_MENU = 'StandardRelatedMenu';
  public static STANDARD_TOOLBAR_OPTIONSMENU_MENU = 'StandardOptionsMenu';
  public static STANDARD_TOOLBAR_ACTIONSMENU_MENU = 'StandardActionsMenu';
  public static STANDARD_TOOLBAR_ALLACTIONSMENU_MENU = 'StandardAllActionsMenu';
  public static STANDARD_TOOLBAR_CHARTMENU_MENU = 'StandardChartsMenu';
  public static STANDARD_TOOLBAR_AUDITCOMPARE = 'StandardAuditCompare';
  public static STANDARD_TOOLBAR_MATRIXSHOWDETAIL = 'StandardMatrixShowDetail';
  public static STANDARD_TOOLBAR_MATRIXHIDEDETAIL = 'StandardMatrixHideDetail';
  public static STANDARD_TOOLBAR_PFCOMPARE = 'StandardPFCompare';
  public static STANDARD_TOOLBAR_SCHEDULE = 'StandardSchedule';
  public static STANDARD_TOOLBAR_USERLISTVIEW_MENU = 'StandardUserListViewMenuButton';
  public static STANDARD_TOOLBAR_USERLISTVIEW_MORE_MENU = 'StandardUserListViewMoreMenuButton'
  public static STANDARD_TOOLBAR_USERLISTVIEW_SAVE = 'StandardUserListViewSaveButton';
  public static STANDARD_TOOLBAR_USERLISTVIEW_SAVEAS = 'StandardUserListViewSaveAsButton';
  public static STANDARD_TOOLBAR_USERLISTVIEW_CLEAR = 'StandardUserListViewClearButton';
  public static STANDARD_TOOLBAR_USERLISTVIEW_MANAGE = 'StandardUserListViewManageButton';
  public static STANDARD_TOOLBAR_USERLISTVIEW = 'StandardUserListView';
  public static STANDARD_TOOLBAR_SAVEDSEARCHES = 'StandardSavedSearches';
  public static STANDARD_TOOLBAR_DOWNLOAD = 'StandardDownload';
  public static STANDARD_TOOLBAR_REFRESHCOLUMNARDATA = 'StandardRefreshColumnarData';
  public static STANDARD_TOOLBAR_GENAISUMMARIZE = 'StandardSummarize';

  public static STANDARD_TOOLBAR_TYPES = [
    AppConstants.STANDARD_TOOLBAR_OPEN,
    AppConstants.STANDARD_SAVE,
    AppConstants.STANDARD_TOOLBAR_SAVENEW,
    AppConstants.STANDARD_TOOLBAR_SAVECLOSE,
    AppConstants.STANDARD_TOOLBAR_SAVEASDRAFT,
    AppConstants.STANDARD_TOOLBAR_EXPORTPDF,
    AppConstants.STANDARD_TOOLBAR_EXPORTCSV,
    AppConstants.STANDARD_TOOLBAR_CREATEREPORT,
    AppConstants.STANDARD_TOOLBAR_SEARCH,
    AppConstants.STANDARD_TOOLBAR_REFRESH,
    AppConstants.STANDARD_TOOLBAR_VIEWACTION,
    AppConstants.STANDARD_TOOLBAR_HELPERLIST,
    AppConstants.STANDARD_TOOLBAR_NAVIGATION,
    AppConstants.STANDARD_TOOLBAR_VIEWAUDIT,
    AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT,
    AppConstants.STANDARD_TOOLBAR_DETAILFIELDS,
    AppConstants.STANDARD_TOOLBAR_NEXTRECORD,
    AppConstants.STANDARD_TOOLBAR_PREVRECORD,
    AppConstants.STANDARD_TOOLBAR_CREATEMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_ACTIONSMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_OPTIONSMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_EXPORTMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_REPORTSMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_PERSONALIZEMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_AUDITMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_RELATEDMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_CHARTMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_ALLACTIONSMENU_BUTTON,
    AppConstants.STANDARD_TOOLBAR_INLINECREATE,
    AppConstants.STANDARD_TOOLBAR_CREATE,
    AppConstants.STANDARD_TOOLBAR_UPDATE,
    AppConstants.STANDARD_TOOLBAR_DELETE,
    AppConstants.STANDARD_TOOLBAR_CREATEMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_RELATEDMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_OPTIONSMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_ACTIONSMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_ALLACTIONSMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_CHARTMENU_MENU,
    AppConstants.STANDARD_TOOLBAR_AUDITCOMPARE,
    AppConstants.STANDARD_TOOLBAR_PFCOMPARE,
    AppConstants.STANDARD_TOOLBAR_DOWNLOAD,
    AppConstants.STANDARD_TOOLBAR_REFRESHCOLUMNARDATA,
    AppConstants.STANDARD_TOOLBAR_GENAISUMMARIZE
  ];

  public static CUBE_TOOLBAR_DIMENSIONS = 'CubeToolbarDimensions';
  public static CUBE_TOOLBAR_SET_CH_DIMENSIONS = 'CubeToolbarSetCHDimensions';
  public static CUBE_TOOLBAR_SET_FILTER_DIMENSIONS = 'CubeToolbarSetFilterDimensions'
  public static CUBE_TOOLBAR_DRILLDOWN_DIMENSIONS = 'CubeToolbarDrillDownDimensions';
  public static CUBE_TOOLBAR_PIVOTVIEWS = 'CubeToolbarPivotViews';
  public static CUBE_TOOLBAR_COLUMNVIEWS = 'CubeToolbarColumnViews';
  public static CUBE_TOOLBAR_PERIODOVERRIDE = 'CubeToolbarPeriodOverride';
  public static CUBE_TOOLBAR_PERIODVIEW = 'CubeToolbarPeriodView';
  public static CUBE_TOOLBAR_CHARTS = 'CubeToolbarCharts';
  public static CUBE_TOOLBAR_OPTIONS = 'CubeToolbarOptions';
  public static CUBE_TOOLBAR_OPTIONS_CUBESTATUS = 'CubeToolbarOptionsCubeStatus';
  public static CUBE_TOOLBAR_PERIODVIEWPERIODS = 'CubeToolbarPeriodViewPeriods';

  public static GALLERY_TOOLBAR_PREVIOUS = 'GalleryToolbarPrevious';
  public static GALLERY_TOOLBAR_NEXT = 'GalleryToolbarNext';
  public static GALLERY_TOOLBAR_VIEW_ALL = 'GalleryToolbarViewAll';

  public static DATAVIEW_REPRESENTATIVE_TEXT_PROPERTY = 'representativeText';

  public static actionName = '_execute';

  // condition types for landmark.condition.isValid
  public static CONDITIONTYPE_ENTERED = 'entered';
  public static CONDITIONTYPE_FIELD = 'field';
  public static CONDITIONTYPE_VALUE = 'value';
  public static CONDITIONTYPE_STATE = 'state';
  public static CONDITIONTYPE_CONTEXT = 'context';
  public static CONDITIONTYPE_DISPLAY = 'display';
  public static DRILL_AROUND_LABEL = 'Drill Around' + String.fromCharCode(174);
  public static DRILL_AROUND_MENU_LABEL = 'Related';

  // Configurable Features
  public static FEATURE_ConfigurableFeatures = 'ConfigurableFeatures';
  public static FEATURE_ExportToCSV = 'ExportToCSV';
  public static FEATURE_ExportToPDF = 'ExportToPDF';
  public static FEATURE_CreateReport = 'CreateReport';
  public static FEATURE_CreateFolder = 'CreateFolder';
  public static FEATURE_CreateWatch = 'CreateWatch';
  public static FEATURE_DataMenu = 'DataMenu';
  public static FEATURE_DrillAroundEnabled = 'DrillAroundEnabled';
  public static FEATURE_SecurityConfiguration = 'SecurityConfiguration';
  public static FEATURE_Configuration = 'Configuration';
  public static FEATURE_Personalization = 'Personalization';
  public static FEATURE_LimitedListPersonalization = 'LimitedListPersonalization';
  public static FEATURE_LimitedFormPersonalization = 'LimitedFormPersonalization';
  public static FEATURE_LandingPagePersonalization = 'LandingPagePersonalization';
  public static FEATURE_AsOfDate = 'AsOfDate';
  public static FEATURE_ShowInbasketWorkFlowActions = 'ShowInbasketWorkFlowActions';
  public static FEATURE_ShowAllScheduleActions = 'ShowAllScheduleActions';
  public static FEATURE_UseAllActorGroups = 'UseAllActorGroups';
  public static FEATURE_SpreadSheetDesigner = 'SpreadSheetDesigner';
  public static FEATURE_SpreadSheetDesignerUpdate = 'SpreadSheetDesignerUpdate';
  public static FEATURE_UserContextMenu = 'UserContextMenu';
  public static FEATURE_ChangePreferredApplicationStartPage = 'ChangePreferredApplicationStartPage';
  public static FEATURE_ShowDeletedRecords = 'ShowDeletedRecords';
  public static FEATURE_ShowArchive = 'ShowArchive';
  public static FEATURE_CSVMULTITHREADING = 'ExportToCSVMultithreadingEnabled';

  // resource types
  public static RESOURCETYPE_ACTION = 'action';
  public static RESOURCETYPE_LIST = 'list';
  public static RESOURCETYPE_TREE = 'tree';
  public static RESOURCETYPE_HIERARCHY = 'hierarchy';
  public static RESOURCETYPE_GALLERY = 'gallery';
  public static RESOURCETYPE_FORM = 'form';
  public static RESOURCETYPE_NAVIGATION = 'navigation';
  public static RESOURCETYPE_SUBPANEL = 'subpanel';
  public static RESOURCETYPE_PAGE = 'page';
  public static RESOURCETYPE_DOCUMENT = 'document';
  public static RESOURCETYPE_RELATION = 'relation';
  public static RESOURCETYPE_DRILL = 'drill';
  public static RESOURCETYPE_SELECT = 'select';
  public static RESOURCETYPE_SEARCH = 'search';
  public static RESOURCETYPE_MENU = 'menu';
  public static RESOURCETYPE_IMAGE = 'image';
  public static RESOURCETYPE_HOME = 'home';
  public static RESOURCETYPE_BANNER = 'banner';
  public static RESOURCETYPE_APPS = 'apps';
  public static RESOURCETYPE_HTML = 'html';
  public static RESOURCETYPE_FORMINVOKE = 'forminvoke';
  public static RESOURCETYPE_FORMPANEL = 'formpanel';
  public static RESOURCETYPE_BIDRILL = 'bidrill';
  public static RESOURCETYPE_PAGEMENU = 'pagemenu';
  public static RESOURCETYPE_PAGEPANEL = 'pagepanel';
  public static RESOURCETYPE_PARENT = 'parent';
  public static RESOURCETYPE_REPORTCATALOG = 'reportcatalog';
  public static RESOURCETYPE_LAND = 'land';


  // 1 day - 1440 minutes
  public static PAGE_STATE_EXPIRATION_IN_MINUTES  = 1440;

  public static INFINITE_PAGESIZE = -1;
  public static ATTACHMENTLIST_MAXFILES = 5;

  // pdf type
  public static REGULAR_LIST_PDF = 'listPdf';
  public static LIST_WITH_DETAILS_PDF = 'listWithDetailsPdf';
  public static TREE_LIST_PDF = 'treeListPdf';
  public static TREE_LIST_WITH_DETAILS_PDF = 'treeListWithDetailsPdf';
  public static REGULAR_FORM_PDF = 'regularFormPdf';
  public static COMPOSITE_FORM_PDF = 'compositeFormPdf';
  public static PAGE_PDF = 'pagePdf';
  public static LIST_WITH_EXPANDABLE_CARD_ROW_PDF = 'listWithExpandableCardRowPdf';

  // pdf print option
  public static PDF_ACTION  = 40;
  public static PDF_WITH_DETAILS_ACTION  = 41;
  public static PDF_SELECTED_WITH_DETAILS_ACTION  = 42;
  public static PDF_EXPANDED_ACTION  = 43;
  public static PDF_EXPANDED_WITH_DETAILS_ACTION  = 44;
  public static PDF_SELECTED_TAB_ACTION  = 45;
  public static PDF_ALL_TABS_ACTION  = 46;
  public static PDF_VIEW_ACTION  = 47;
  public static PDF_SPECIFIED_ACTION  = 48;
  public static PDF_SPECIFIED_WITH_DETAILS_ACTION  = 49;

  //CSV type
  public static REGULAR_LIST_CSV = 'listCSV'
  public static LIST_WITH_DETAILS_CSV = 'listWithDetailsCSV';
  public static TREE_LIST_CSV = 'treeListCSV';
  public static TREE_LIST_WITH_DETAILS_CSV = 'treeListWithDetailsCSV';

  //CSV export options
  public static CSV_ACTION							= 50;
  public static CSV_SPECIFIED_ACTION                = 51;
  public static CSV_WITH_DETAILS_ACTION             = 77;
  public static CSV_WITH_DETAILS_ACTION_DETAILSONLY = 1;
  public static CSV_SELECTED_WITH_DETAILS_ACTION    = 78;
  public static CSV_EXPANDED_ACTION                 = 79;
  public static CSV_EXPANDED_WITH_DETAILS_ACTION    = 106;
  public static CSV_SPECIFIED_WITH_DETAILS_ACTION   = 107;

  //CSV details option
  public static CSV_DETAILS_COMBINED                = 108;
  public static CSV_DETAILS_CONTEXT                 = 109;
  public static CSV_DETAILS_ONLY                    = 110;

  public static CONDITION_AND = ' and ';
  public static CONDITION_OR = ' or ';

  // row index of the inline create row
  public static INLINE_CREATE_ROW  = 0;

  // delimiter for multiple search term values
  public static MULTI_SEARCH_TERM_DELIMITER = ';';

  public static DEFAULT_LINE_HEIGHT  = 20;

  // display value for percent of total that are not yet calculated
  public static PERCENT_OF_TOTAL_INDETERMINATE_VALUE = '###';

  // css class names for controls
  public static CSS_MENU_SEPARATOR = 'separator';

  public static CLASS_BANNER_ENABLETABS = 'has-tabs';

  public static DATA_SOHO_TABS = 'tabs';

  public static STEP_PROCESS_UNVISITED_ICON = 'empty-circle';
  public static STEP_PROCESS_INPROCESS_ICON = 'half-empty-circle';  // half-empty-circle  in-progress
  public static STEP_PROCESS_COMPLETE_ICON = 'success';
  public static STEP_PROCESS_ERROR_ICON = 'error';

  public static TESTVERSION_V1 = 1;
  public static TESTVERSION_V2 = 2;
  public static TESTVERSION_V3 = 3;

  public static BREADCRUMB_URL_PARAM = '_bcc';

  public static OperatorMap: OperatorMapping[] = [
    { lmOperator: 'equals', sohoOperator: 'equals' },
    { lmOperator: 'doesNotEqual', sohoOperator: 'does-not-equal' },
    { lmOperator: 'contains', sohoOperator: 'contains' },
    { lmOperator: 'doesNotContain', sohoOperator: 'does-not-contain' },
    { lmOperator: 'isEmpty', sohoOperator: 'is-empty' },
    { lmOperator: 'isNotEmpty', sohoOperator: 'is-not-empty' },
    { lmOperator: 'lessThan', sohoOperator: 'less-than' },
    { lmOperator: 'lessThanOrEquals', sohoOperator: 'less-equals' },
    { lmOperator: 'greaterThan', sohoOperator: 'greater-than' },
    { lmOperator: 'greaterThanOrEquals', sohoOperator: 'greater-equals' },
    { lmOperator: 'endsWith', sohoOperator: 'end-with' },
    { lmOperator: 'doesNotEndWith', sohoOperator: 'does-not-end-with' },
    { lmOperator: 'startsWith', sohoOperator: 'start-with' },
    { lmOperator: 'doesNotStartWith', sohoOperator: 'does-not-start-with' },
    { lmOperator: 'selected', sohoOperator: 'selected' },
    { lmOperator: 'notSelected', sohoOperator: 'not-selected' },
    { lmOperator: 'inRange', sohoOperator: 'in-range' },
    { lmOperator: 'all', sohoOperator: 'selected-notselected' }
  ];

  public static LM_FORM_URL_PAGING_PARAMS: LMFormUrlPagingParamType[] = [
    'hasNext', 'hasPrevious', 'firstDisabled', 'lastDisabled',
    'nextDisabled', 'previousDisabled', 'isAscending', 'sortOrderName', 'fk', 'lk', 'pk',
  ];

  /**
   * Suffix for filterCriteria url params to tell the server to filter
   * by the base language and not the current locales language
   */
  public static DTF_SUFFIX = '.dtf';
}

export type LMBreadcrumbsByCategory = { [category: string]: Array<SohoBreadcrumbItemOptions> };

export enum LMTimeStampDirective {
  DISPLAY_DATE = 1,
  DISPLAY_TIME,
  DISPLAY_HOURS_AND_MINUTES,
  DISPLAY_DATE_AND_HOURS_AND_MINUTES
}

export interface LMTransformOptions {
  decSize?: number;
  precision?: number;
  noSymbol?: boolean;                   // true - do not display percent sign
  displayZero?: boolean;                // true - display zero for a number
  displayThousandsCharacter?: boolean;  // true - display group separator for a number
  hasStateValues?: boolean;
  isCompoundField?: boolean;
  // date time properties
  timeStampDirective?: LMTimeStampDirective;  // for TimeStamp and Time types
  timeStampDataValue?: string;          // current TimeStamp data value for displayHoursAndMinutesOnly and displayTimeOnly
  isRange?: boolean;
  locale?: string;
  calendarName?: string;
  timeZone?: string;
  displayWithTimeZone?: boolean;

  displayInThousands?: boolean;     // for List BCD display only
  displayInMillions?: boolean;      // for List BCD display only
  displayNegativeParens?: boolean | string;  // for List BCD|PERCENT|NUMERIC display only
  disableDST?: boolean;
  allowMultiSelections?: boolean;
  maintainSelectedValues?: boolean;
  showPercentSymbol?: boolean;
  currencySymbolIs?: string;
  doNotTransform?: boolean;
  forceFromPattern?: string;
  forceToPattern?: string; // for date format = short, long

  hasDisplayWhen?: boolean;
  formFieldDisplayWhen?: LMFormFieldDisplayWhen;
}

export interface LMFormFieldDisplayWhen {
  displayMsgRule: LMMessageRule;
  displayWhen: LMCondition;
  model: LMModel;
}

export enum FormRequestType {
  BusClassOntology             = 'busClassOntology',
  RelatedBusClassNames         = 'relatedBusClassNames',
  BusClassNames                = 'busClassNames',
  ConditionNamesForBusClass    = 'conditionNamesForBusClass',
  CreateReport                 = 'createReport',
  DataViewDataFormInfo         = 'dataViewDataFormInfo',
  DataViewDataFieldValue       = 'dataViewDataFieldValue',
  DeleteListPersonalization    = 'deleteListPersonalization',
  DrillPoints                  = 'drillPoints',
  FieldHistory                 = 'fieldHistory',
  FieldPendingChanges          = 'fieldPendingChanges',
  FieldTranslations            = 'fieldTranslations',
  FormInvoke                   = 'formInvoke',
  DefineFormUrl                = 'defineFormUrl',
  InitialValue                 = 'initialValue',
  RequestFields                = 'requestFields',
  ListNamesAndViewsForBusClass = 'listNamesAndViewsForBusClass',
  ListNamesForBusClass         = 'listNamesForBusClass',
  RelatedSelectValues          = 'relatedSelectValues',
  SaveListPersonalization      = 'saveListPersonalization',
  SchedulePdf                  = 'schedulePdf',
  SelectPaging                 = 'SelectPaging',
  UserDefinedStates            = 'userDefinedStates',
  ValidateCondition            = 'validateCondition',
  ValidateField                = 'validateField',
  RefreshSubPanelList          = 'refreshSubPanelList',
  CubeDimensionMapping         = 'cubeDimensionMapping',
  CubeGetTopNodesForContext    = 'cubeGetTopNodesForContext',
  CubeRelDimensionMapping      = 'cubeRelDimensionMapping',
  CubeRelationLPL              = 'cubeRelationLpl',
  CubeRelGetSelectValue        = 'cubeRelGetSelectValue',
  CubeRelGetMeasures           = 'cubeRelGetMeasures',
  CubeRelTestMeasure           = 'cubeRelTestMeasure',
  CubeRelValidateLPL           = 'cubeRelValidateLPL',
  FieldValues                  = 'fieldValues',
  SearchInitialValues          = 'searchInitialValues',
  SearchDrillbackValues        = 'searchDrillbackValues',
  SecurableActionsList         = 'securableActionsList',
  SecurableObjectsList         = 'securableObjectsList',
  //create report
  ListDisplayFields            = 'listDisplayFields',
  ReportNamesForCreateReport   = 'reportNamesForCreateReport',
  ListNamesForCreateReport     = 'listNamesForCreateReport',
  DisplayFieldsSpec            = 'displayFieldsSpec',
  PrimaryList                  = 'primaryList',
  CubeDimensions               = 'cubeDimensions',
  Modules                      = 'modules',
  CategoriesByModule           = 'categoriesByModule',
  WebApps                      = 'webApps',
  GenAILLMModels               = 'genAILLMModels'
}

export enum ListRequestType {
  FieldSpecForBusClass         = 'fieldSpecForBusClass',
}

// keys used in dialogs for dialog button text translation and for dialog button id
export enum LMDialogButtonKey {
  APPEND              = 'Append',
  APPLY               = 'Apply',
  CANCEL              = 'Cancel',
  CLEAR               = 'Clear',
  CLOSE               = 'Close',
  COMPARE             = 'Compare',
  COPY                = 'Copy',
  COPYANDVIEWREPORT   = 'CopyAndViewReport',
  CREATEANDVIEWREPORT = 'CreateAndViewReport',
  CREATEREPORT        = 'CreateReport',
  DISCARDCHANGES      = 'DiscardChanges',
  DISMISS             = 'Dismiss',
  EMAIL               = 'Email',
  EXPORT              = 'Export',
  FOREGROUND          = 'Foreground',
  INSERT              = 'Insert',
  LEAVE               = 'Leave',
  OK                  = 'Ok',
  OKTOALL             = 'OKToAll',
  PRINT               = 'Print',
  RESET               = 'Reset',
  RUNINBACKGROUND     = 'RunInBackground',
  SAVE                = 'Save',
  SAVEASDRAFT         = 'SaveAsDraft',
  SCHEDULE            = 'Schedule',
  SIGNOUT             = 'SignOut',
  STAY                = 'Stay',
  SUBMIT              = 'Submit',
  YES                 = 'Yes',
  NO                  = 'No',
  DONEEDITING         = 'DoneEditing',
  CONTINUE            = 'Continue',
  BACK                = 'Back'
}
export interface LMFormInvokeUrlPostContent {
  requestType: FormRequestType;
  formInvokeName: string;
  dataView: LMDataView;
}

export interface LMFormInvokeUrlResponse {
  actionSpec: LMActionSpec;
  redirectUrl: string;
  message?: string;
  status?: string;
  details?: string;
}

// export type LMListType = _LMListType;

// export LMListType = _LMListType;

// export enum LMListType {
//   DEFAULT = 'default',
//   SELECT = 'select',
//   HELPER = 'helper',
//   DASHBOARD = 'dashboard',
//   FORMLIST = 'formlist',
//   MULTILIST = 'multilist',
//   MULTIPANE = 'multipane',
//   DETAILSECTION = 'detailsectionlist',
//   POPOVER = 'popover',
//   CUBEVIEW = 'cubeview',
// }

export enum LMButtonType {
  ACTION = 'action',
  STANDARD_ACTION = 'standard',
  NAVIGATION = 'navigation',
  RELATED = 'related',
  HTTPURL = 'httpurl',
  FORMINVOKE = 'forminvoke',
  PROCESSFLOW = 'processflow',
  LIST_REFERENCE = 'listReference',
  SUBFORM = 'subform',
  HELPERLIST = 'helperList',
  FORMBUTTON = 'FormButton',
  SHOWEDITOR = 'showeditor',
  VIEWDOCUMENT = 'viewdocument',
  EXPORTDOCUMENT = 'exportdocument',
  CHART = 'chart',
  REGISTRATION= 'registration',
  SIGNIN = 'signin',
  SIGNOUT = 'signout'
}

export enum LMFormType {
  SEARCH = 'Search',
  STANDARD = 'Standard',
  COMPOSITE = 'Composite',
  CHART = 'Chart',
  MENU = 'Menu',
  MATRIX = 'Matrix',
  ACTION = 'Action',
  PAGE_CONTEXT = 'PageContext'
}

// Defined in IActionRequest.java
export enum LMActionRequestStatus {
  NOTINPROCESS = '1',
  INPROCESS = '2',
  REJECTED = '8',
  COMPLETE = '9'
}

export enum LMActionRequestSaveMode {
  DRAFT = 'draft',
  SUBMIT = 'submit'
}

export enum FilterBuilderDialogResult {
  CONFIRMATION_CANCEL = 0,
  CONFIRMATION_OVERWRITE,
  CONFIRMATION_APPEND,
  CONFIRMATION_OK
}

export enum LMToolbarActionTypeEnum {
  'ACTION' = 'action',
  'CALENDAR' = 'calendar',
  'CHART' = 'chart',
  'LIST' = 'list',
  'HIERARCHY' = 'hierarchy',
  'TREE' = 'tree',
  'HELPER_LIST' = 'helperList',
  'NAVIGATION' = 'navigation',
  'PROCESS_FLOW' = 'processflow',
  'PERSONALIZE' = 'personalize',
  'RELATED' = 'related',
  'CUBE' = 'cube',
  'SEPARATOR' = 'separator',
  'STANDARD' = 'standard',
  'NOOP' = 'noop',
  'SAVE_SEARCH' = 'savesearch',
  'FORM_BUTTON' = 'FORMBUTTON',
  'GALLERY_NEXT' = 'galleryNext',
  'GALLERY_PREVIOUS' = 'galleryPrevious',
  'VIEW_ALL' = 'viewall'
}
